import _defineProperty from "/home/runner/work/KEKPETS_FRONTEND/KEKPETS_FRONTEND/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/runner/work/KEKPETS_FRONTEND/KEKPETS_FRONTEND/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/KEKPETS_FRONTEND/KEKPETS_FRONTEND/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function e(e, t, n) {
  var r = [d.run({
    fn: function fn(e) {
      return t(e);
    }
  })];

  if (n) {
    var _t = y({
      node: r
    }),
        _o = e.graphite.id,
        _u = n.additionalLinks,
        _a = _u[_o] || [];

    return _u[_o] = _a, _a.push(_t), function () {
      var e = _a.indexOf(_t);

      -1 !== e && _a.splice(e, 1), k(_t);
    };
  }

  {
    var _t2 = y({
      node: r,
      parent: [e],
      family: {
        owners: e
      }
    });

    return function () {
      k(_t2);
    };
  }
}

function t(e, t) {
  return t.displayName = e, t;
}

function n(t, n) {
  g.store(t) || S('expect useStore argument to be a store');
  var r = w(t, n),
      o = N(),
      u = m.useRef({
    store: t,
    value: r,
    pending: 0
  });
  return b(function () {
    var r = e(t, function (e) {
      var t = u.current;
      t.pending || (t.value = e, t.pending = 1, o(), t.pending = 0);
    }, n),
        a = w(t, n),
        s = u.current;
    return s.store === t && s.value !== a && (s.value = a, s.pending = 1, o(), s.pending = 0), s.store = t, r;
  }, [t, n]), r;
}

function r(_ref, r) {
  var _ref2 = _slicedToArray(_ref, 2),
      t = _ref2[0],
      n = _ref2[1];

  var u,
      a,
      s,
      l = j;
  n ? (u = n, a = t, s = []) : (u = t.fn, a = t.store, s = t.keys, l = t.updateFilter || j), g.store(a) || S('useStoreMap expects a store'), Array.isArray(s) || S('useStoreMap expects an array as keys'), 'function' != typeof u && S('useStoreMap expects a function');
  var c = m.useRef({}),
      i = c.current;
  i.fn = u, i.upd = l, i.init = i.store === a, i.store = a;
  var f = N(),
      p = [r].concat(_toConsumableArray(s)),
      d = m.useMemo(function () {
    return o(w(a, r), s, c.current), e(a, function (e) {
      return o(e, s, c.current, f);
    }, r);
  }, p);
  return b(function () {
    return function () {
      return d();
    };
  }, p), i.val;
}

function o(e, t, n, r) {
  var o = n.fn(e, t);
  n.init ? void 0 !== o && j(o, n.val) && n.upd(o, n.val) && (n.val = o, r && r()) : (n.val = o, n.init = 1);
}

function u(e) {
  return e;
}

function a(e) {
  return n(e);
}

function s(e, t) {
  return r([e, t]);
}

function l(e, o) {
  return function (e, o, u) {
    var a,
        s,
        l = [];
    'object' == typeof o && null !== o ? (o.keys && (l = o.keys), a = o.fn, o.getKey && (s = o.getKey)) : a = o, g.store(e) || S('expect useList first argument to be a store'), 'function' != typeof a && S("expect useList's renderItem to be a function"), Array.isArray(l) || S("expect useList's keys to be an array");
    var c = m.useMemo(function () {
      var n = t("".concat(e.shortName || 'Unknown', ".Item"), function (t) {
        var n = t.index,
            o = t.keys,
            a = t.keyVal,
            s = t.value;
        if (i.current[1]) return i.current[0](s, a);
        var l = r([{
          store: e,
          keys: [n].concat(_toConsumableArray(o)),
          fn: function fn(e, t) {
            return e[t[0]];
          }
        }], u);
        return i.current[0](l, n);
      });
      return m.memo(n);
    }, [e, u, !!s]),
        i = m.useRef([a, s]);
    i.current = [a, s];
    var f = m.useMemo(function () {
      return l;
    }, l);
    if (s) return n(e, u).map(function (e) {
      var t = i.current[1](e);
      return m.createElement(c, {
        keyVal: t,
        key: t,
        keys: f,
        value: e
      });
    });
    {
      var _t3 = r([{
        store: e,
        keys: [e],
        fn: function fn(e) {
          return e.length;
        }
      }], u);

      return Array.from({
        length: _t3
      }, function (e, t) {
        return m.createElement(c, {
          index: t,
          key: t,
          keys: f
        });
      });
    }
  }(e, o);
}

function c(e, n) {
  function r(e) {
    var t = m.useRef(e),
        r = a(o);
    b(function () {
      return s({
        props: t.current,
        state: o.getState()
      }), function () {
        l({
          props: t.current,
          state: o.getState()
        });
      };
    }, []);
    var u = n(e, r);
    return t.current = e, u;
  }

  var o;
  g.store(e) ? o = e : 'object' == typeof e && null !== e ? o = v(e) : S('shape should be a store or object with stores');
  var u = 'Unknown';
  o && o.shortName && (u = o.shortName);
  var s = h(),
      l = h();
  return r.mounted = s, r.unmounted = l, t("".concat(u, ".View"), r);
}

function i(e) {
  return c(e, function (_ref3, t) {
    var e = _ref3.children;
    return e(t);
  });
}

function f(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var n = m.useRef({
    value: null,
    count: 0
  });
  b(function () {
    return e.open(n.current.value), function () {
      return e.close(n.current.value);
    };
  }, [e]), function (e, t) {
    if (e === t) return 1;

    if ('object' == typeof e && null !== e && 'object' == typeof t && null !== t) {
      var _n = Object.keys(e),
          _r = Object.keys(t);

      if (_n.length !== _r.length) return 0;

      for (var _r2 = 0; _r2 < _n.length; _r2++) {
        var _o2 = _n[_r2];
        if (e[_o2] !== t[_o2]) return 0;
      }

      return 1;
    }

    return 0;
  }(n.current.value, t) || (n.current.value = t, n.current.count += 1), b(function () {
    e.set(n.current.value);
  }, [n.current.count]);
}

function p() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "gate";
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var r;
  return 'object' == typeof e && null !== e && ('defaultState' in e && (n = e.defaultState), e.domain && (r = e.domain), e = e.name), function (_ref4) {
    var _ref4$name = _ref4.name,
        e = _ref4$name === void 0 ? "gate" : _ref4$name,
        n = _ref4.domain,
        r = _ref4.defaultState,
        o = _ref4.hook;

    function u(e) {
      return o(u, e), null;
    }

    var a = "".concat(n ? "".concat(n.compositeName.fullName, "/") : '').concat(e),
        s = h("".concat(a, ".set")),
        l = h("".concat(a, ".open")),
        c = h("".concat(a, ".close")),
        i = x(Boolean(0), {
      name: "".concat(a, ".status")
    }).on(l, function () {
      return Boolean(1);
    }).on(c, function () {
      return Boolean(0);
    }),
        f = x(r, {
      name: "".concat(a, ".state")
    }).on(s, function (e, t) {
      return t;
    }).reset(c);

    if (n) {
      var _e = n.hooks;
      $({
        target: [_e.store, _e.store, _e.event, _e.event, _e.event],
        params: [i, f, l, c, s]
      });
    }

    return u.open = l, u.close = c, u.status = i, u.state = f, u.set = s, t("Gate:".concat(a), u);
  }({
    name: e,
    domain: r,
    defaultState: n,
    hook: f
  });
}

import m from 'react';
import { step as d, createNode as y, clearNode as k, is as g, combine as v, createEvent as h, createStore as x, launch as $ } from 'effector/effector.mjs';

var b = 'undefined' != typeof window ? m.useLayoutEffect : m.useEffect,
    S = function S(e) {
  throw Error(e);
};

var w = function w(e, t) {
  return t ? t.getState(e) : e.getState();
},
    j = function j(e, t) {
  return e !== t;
},
    N = function N() {
  return m.useReducer(function (e) {
    return e + 1;
  }, 0)[1];
};

var R = function R(e) {
  return console.error("".concat(e, " is deprecated"));
},
    C = function C(e, n, r) {
  return R('createContextComponent'), t("".concat(e.shortName || 'Unknown', ".ContextComponent"), function (t) {
    var o = m.useContext(n),
        u = a(e);
    return r(t, u, o);
  });
},
    E = function E(e) {
  return function (n) {
    var r = e;
    return 'function' != typeof e && (r = n, n = e), t("Connect(".concat(r.displayName || r.name || 'Unknown', ")"), function (e) {
      return m.createElement(r, _objectSpread(_objectSpread({}, e), a(n)));
    });
  };
},
    M = function M(e, t) {
  return R('createReactState'), E(t)(e);
};

export { E as connect, c as createComponent, C as createContextComponent, p as createGate, M as createReactState, i as createStoreConsumer, u as useEvent, f as useGate, l as useList, a as useStore, s as useStoreMap };